import { getScoreReaderTotal, ScoreReader } from '@upright/common/model/output/scores/score-reader';
import { useSelector } from 'react-redux';
import { getValueSet, getValueSetName } from '../../../../../../../../../untidy/redux/selectors';
import { useImpactChartContext } from '../../../context';
import { NetScoreBlock } from './index';

interface Props {
  onContributeClick?: () => void;
}

export function NetScoreBlockCustom(_props: Props) {
  const data = useImpactChartContext().data;
  const datum = data[0];
  const valueSet = useSelector(getValueSet);
  const valueSetName = useSelector(getValueSetName);
  const scoreUnit = useImpactChartContext().scoreType;
  const netScoreFormat = useImpactChartContext().netScoreFormat;
  if (data.length === 0) {
    return <></>;
  }
  const scoreReader = new ScoreReader(datum.impactScoresByTIVV, scoreUnit, datum.revenue, valueSet);
  const netScore = getScoreReaderTotal(scoreReader, netScoreFormat);
  return <NetScoreBlock value={netScore} valueSetName={valueSetName} />;
}
